import { requestGET } from '@/api';
import { FundsEntity } from '@/entities/investment/fund';
import { StocksEntity } from '@/entities/investment/stock';

export const getStockInvestments = (): Promise<StocksEntity> =>
  requestGET('/v1/invest/users/me/stocks');

export const getFundInvestments = (): Promise<FundsEntity> =>
  requestGET('/v1/invest/users/me/funds');
